import React, { useContext, useEffect, useState } from "react";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import { PortalContext } from "../../context/Provider";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import Loading from "../../components/Genericos/Loading/Loading";
import { GlobalContext } from "../../../global/context/Provider";
import {
  BodyMisRecetas,
  CardRecetaMotion,
  CardsRecetaBox,
  CardsRecetaBoxMotion,
  LineaSeparadora,
  RecetaContainerMotion,
} from "./localStyle";
import Tooltip from "global/component/Genericos/Tooltip/Tooltip";
import PdfIcon from "_+_Portal/assets/images/generico/PdfIcon";
import DescargarIcon from "_+_Portal/assets/images/generico/DescargarIcon";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import {
  recetasDigitalesReset,
  wsGetMisRecetas,
} from "_+_Portal/context/Actions/turnos/recetaDigital";
import { showToaster } from "global/context/action/toaster/toaster";
import { getStrDateYear } from "global/utils/diasData";
import { detectarIOS } from "global/utils/detectarIOS";
import { base64toBlob } from "global/utils/base64toBlob";
import { Device } from "@capacitor/device";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import camelize from "global/utils/camelize";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import { isMobile } from "global/utils/platformDetector";
import BtnVolver from "_+_Portal/components/Genericos/BtnVolver/BtnVolver";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import { container, dots, pageContainerVariants } from "global/utils/cardAnimation";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const MisRecetas = () => {
  const {
    recetasDigitalesState,
    modalDispatch,
    selectDropDownState,
    recetasDigitalesDispatch,
  } = useContext(PortalContext);
  const { toasterState, authState, toasterDispatch } =
    useContext(GlobalContext);
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [recetasData, setRecetasData] = useState([]);

  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const downloadiOSFileNative = (item) => {
    const b64Data = item.pdfBase64;
    const fileName = `RecetaDig-${item.id}.pdf`;
    Filesystem.writeFile({
      path: fileName,
      data: b64Data,
      directory: Directory.Documents,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const currentDate = new Date().toLocaleString().replace(/[,:\s\/]/g, "-");

  const downloadPdfAndroidNative = (item) => {
    const b64Data = item.pdfBase64;
    const fileName = `RecetaDig-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: `Download/${fileName}`,
      data: b64Data,
      directory: Directory.ExternalStorage,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const visualizarReceta = (item) => {
    showModal(
      "Genericos/InformePDF/RecetaPDF",
      {
        titulo: `Receta Digital`,
        dissmiss: dissmiss,
        pdf: item.pdfBase64,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const descargarReceta = (item) => {
    const isIOS = detectarIOS();
    if (isIOS) {
      Device.getInfo().then((info) => {
        if (info.platform === "web") {
          const b64Data = item.pdfBase64;
          const contentType = "data:application/pdf";
          const blob = base64toBlob(b64Data, contentType);
          const blobUrl = URL.createObjectURL(blob);
          const descarga = document.createElement(`a`);
          descarga.href = blobUrl;
          descarga.target = "_blank";
          descarga.download = `RecetaDig-${item.id}.pdf`;
          document.body.appendChild(descarga);
          descarga.click();
          document.body.removeChild(descarga);
        } else {
          downloadiOSFileNative(item);
        }
      });
    } else {
      Device.getInfo().then((info) => {
        if (info.platform === "web") {
          const descarga = document.createElement("a");
          descarga.href = `data:application/pdf;base64,${item.pdfBase64}`;
          descarga.target = "_blank";
          descarga.download = `RecetaDig-${item.id}.pdf`;
          document.body.appendChild(descarga);
          descarga.click();
        } else {
          downloadPdfAndroidNative(item);
        }
      });
    }
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const limpiarReceta = () => {
    recetasDigitalesReset()(recetasDigitalesDispatch);
  };

  const cargarRecetas = (isCorrect, data) => {
    if (isCorrect) {
      setRecetasData(data?.recetas);
    } else if (data?.error !== null) {
      showToaster(
        {
          texto: data?.error?.errorMessage
            ? data?.error?.errorMessage
            : "Error al cargar las recetas digitales.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    if (
      authState.auth.data.paciente.codigo > 0 &&
      authState.auth.data.paciente.nroDocumento > 0
    ) {
      wsGetMisRecetas(
        authState.auth.data.paciente.codigo,
        authState.auth.data.paciente.nroDocumento,
        true,
        cargarRecetas
      )(recetasDigitalesDispatch);
    } else {
      showToaster(
        {
          texto: "Los datos del paciente no son correctos.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  }, []);

  return (
    <React.Fragment>
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={recetasDigitalesState.recetasDigitales.loading}
        color="c-white"
        descripcion={
          recetasDigitalesState.recetasDigitales.loading &&
          "Cargando Recetas Digitales..."
        }
      />
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
        nextFnc={limpiarReceta}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Mis Recetas"} />
      {/* <MultitabMobile posicionMultitab={3} /> */}
      <BodyMisRecetas className="ptur-bodyContainer-misRecetas">
        <Sidebar nextFnc={limpiarReceta} />
        {/* <BtnVolver to="/autocheckin" label="Volver" /> */}
        <RecetaContainerMotion
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"ptur-misRecetas-boxGrid"}
        >
          <p className="rb24b ptur-misRecetas-tituloPagina">
            Visualiza, descargá y compartí tus recetas digitales
          </p>
          <hr className="ptur-misMedicos-lineaSeparadora" />
          <CardsRecetaBoxMotion
            key={recetasData?.length}
            variants={container(0.1)}
            initial="hidden"
            animate="visible"
            $empty={recetasData?.length === 0}
          >
            {!recetasDigitalesState.recetasDigitales.loading && (
              <CardsRecetaBox>
                {recetasData.length > 0 ? (
                  recetasData?.map((item) => (
                    <CardRecetaMotion
                      key={item.id}
                      className="itemCardReceta"
                      variants={dots()}
                    >
                      <p className="rb18m c-white tituloCard">
                        Emitida: {getStrDateYear(new Date(item.fechaAlta))}
                      </p>
                      <div className="bodyCard">
                        <p className="rb16l ">
                          Solicitado por:{" "}
                          <span className="rb16m">
                            {camelize(item.medicoDescripcion)}
                          </span>
                        </p>
                        <p>
                          Especialidad:{" "}
                          <span className="rb16m">
                            {camelize(item.especialidadDescripcion)}
                          </span>{" "}
                        </p>
                        <p>
                          Fecha de vencimiento:{" "}
                          <span className="rb16m">
                            {new Date(
                              item.fechaVencimiento
                            ).toLocaleDateString("es-AR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "2-digit",
                            })}
                          </span>{" "}
                        </p>
                        <LineaSeparadora />
                        <div className="iconContainer">
                          <Tooltip
                            customCss={"recetaTooltip"}
                            descripcion={"Descargar Receta"}
                            data={
                              <div
                                className={
                                  "ptur-misLaboratorios-iconoDescargar"
                                }
                                onClick={() => descargarReceta(item)}
                              >
                                <DescargarIcon
                                  color={"#006199"}
                                  width={20}
                                  height={20}
                                />
                              </div>
                            }
                          />
                          {!isMobile && (
                            <Tooltip
                              customCss={"recetaTooltip"}
                              descripcion={"Ver Receta"}
                              data={
                                <div
                                  className={
                                    "ptur-misLaboratorios-iconoDescargar"
                                  }
                                  onClick={() => visualizarReceta(item)}
                                >
                                  <PdfIcon
                                    color={"#006199"}
                                    width={20}
                                    height={20}
                                  />
                                </div>
                              }
                            />
                          )}
                        </div>
                      </div>
                    </CardRecetaMotion>
                  ))
                ) : (
                  <TurnoNoEncontrado
                    state={recetasData}
                    loadingState={false}
                    texto={"No se encuentran registros de recetas digitales."}
                    txtBtn="Buscar un turno"
                    showBtn={false}
                  />
                )}
              </CardsRecetaBox>
            )}
          </CardsRecetaBoxMotion>
        </RecetaContainerMotion>
        <FloatingScroll body={"ptur-misRecetas-boxGrid"} />
      </BodyMisRecetas>
    </React.Fragment>
  );
};

export default MisRecetas;
